'use client'
export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <div style={{ fontFamily:'Inter, sans-serif', minHeight:'100vh', background:'#0B132B', display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center', padding:20 }}>
      <div>
        <div style={{ fontSize:80, marginBottom:16 }}>⚠️</div>
        <h1 style={{ fontSize:32, fontWeight:800, color:'white', margin:'0 0 12px' }}>Something went wrong</h1>
        <p style={{ color:'rgba(255,255,255,0.6)', fontSize:15, margin:'0 0 28px', maxWidth:400 }}>{error.message || 'An unexpected error occurred. Please try again.'}</p>
        <div style={{ display:'flex', gap:12, justifyContent:'center' }}>
          <button onClick={reset} style={{ background:'#0E7C61', color:'white', border:'none', borderRadius:12, padding:'13px 28px', fontSize:15, fontWeight:700, cursor:'pointer' }}>Try Again</button>
          <a href="/" style={{ background:'rgba(255,255,255,0.1)', color:'white', borderRadius:12, padding:'13px 28px', fontSize:15, fontWeight:700, textDecoration:'none' }}>Go Home</a>
        </div>
      </div>
    </div>
  )
}
